{
  "tabs": {
    "chat": "چت",
    "reminders": "یادآورها",
    "calendar": "تقویم",
    "settings": "تنظیمات"
  },
  "common": {
    "cancel": "لغو",
    "save": "ذخیره",
    "confirm": "تأیید",
    "delete": "حذف",
    "back": "بازگشت",
    "close": "بستن",
    "edit": "ویرایش",
    "search": "جستجو",
    "all": "همه",
    "loading": "در حال بارگذاری...",
    "error": "خطایی رخ داد",
    "notFound": "یافت نشد",
    "tryAgain": "لطفاً دوباره تلاش کنید",
    "retry": "تلاش مجدد",
    "undo": "بازگردانی",
    "pullToRefresh": "برای تازه‌سازی بکشید",
    "justNow": "همین الان"
  },
  "auth": {
    "welcome": "به FishMemory خوش آمدید",
    "tagline": "دستیار یادآوری WhatsApp شما، حالا در جیب شما.",
    "subtitle": "دستیار یادآوری WhatsApp شما، حالا در جیب شما.",
    "phoneLabel": "شماره WhatsApp شما",
    "phoneHint": "کد تایید از طریق WhatsApp ارسال می‌شود",
    "invalidPhone": "لطفاً شماره تلفن معتبر وارد کنید",
    "continue": "ادامه",
    "enterPhone": "شماره WhatsApp خود را وارد کنید",
    "phonePlaceholder": "شماره تلفن",
    "sendCode": "ارسال کد",
    "verifyTitle": "شماره خود را تایید کنید",
    "otpSentTo": "کد ۶ رقمی به {{phone}} از طریق WhatsApp ارسال شد",
    "enterFullCode": "لطفاً هر ۶ رقم را وارد کنید",
    "invalidOtp": "کد نامعتبر است. لطفاً دوباره تلاش کنید.",
    "otpFailed": "ارسال کد ناموفق بود. دوباره تلاش کنید.",
    "otpResent": "کد دوباره ارسال شد",
    "resendIn": "ارسال مجدد در {{seconds}} ثانیه",
    "resendCode": "ارسال مجدد کد",
    "enterOtp": "کد ارسال شده به WhatsApp خود را وارد کنید",
    "verify": "تأیید",
    "resend": "ارسال مجدد کد",
    "wrongNumber": "شماره اشتباه است؟",
    "backToPhone": "بازگشت به شماره",
    "editPhone": "ویرایش شماره تلفن",
    "error": "خطا",
    "setupTitle": "بیایید تنظیم کنیم",
    "setupSubtitle": "می‌توانید بعداً در تنظیمات تغییر دهید",
    "namePlaceholder": "نام شما",
    "letsGo": "پایان تنظیم",
    "skipForNow": "فعلاً رد شو"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "پیامی بنویسید...",
    "inputPlaceholder": "پیامی بنویسید...",
    "typing": "FishMemory در حال تایپ است...",
    "online": "آنلاین",
    "connecting": "در حال اتصال...",
    "reconnecting": "در حال اتصال مجدد...",
    "offline": "آفلاین",
    "empty": "شروع گفتگو",
    "emptyHint": "یادآورها بسازید، برنامه‌تان را ببینید یا کمک بگیرید.",
    "emptyAction": "ارسال یادآور نمونه",
    "actions": "عملیات چت",
    "keep": "نگه داشتن پیام‌ها",
    "clearTitle": "پاک کردن چت",
    "clearConfirm": "تمام پیام‌ها از این دستگاه حذف شوند؟ این قابل بازگشت نیست.",
    "clear": "پاک کردن چت",
    "optionSelected": "انتخاب شده: {{label}}",
    "sendingSelection": "در حال ارسال...",
    "connectionLost": "در حال اتصال مجدد..."
  },
  "reminders": {
    "title": "یادآورهای من",
    "active": "فعال",
    "today": "امروز",
    "thisWeek": "این هفته",
    "history": "تاریخچه",
    "items": "مورد",
    "emptyTitle": "هنوز یادآوری ندارید",
    "emptySubtitle": "یکی از چت بسازید تا اینجا نمایش داده شود.",
    "emptyAction": "باز کردن چت",
    "filterActive": "فعال",
    "filterToday": "امروز",
    "filterWeek": "این هفته",
    "filterHistory": "تاریخچه",
    "emptyState": "هنوز یادآوری ندارید. شروع به چت کنید!",
    "swipeDone": "انجام شده",
    "swipeSnooze": "تعویق",
    "swipeDelete": "حذف",
    "search": "جستجوی یادآورها...",
    "upcoming": "آینده",
    "completed": "انجام شده",
    "overdue": "سررسید گذشته",
    "tomorrow": "فردا",
    "synced": "همگام‌سازی شده {{value}}",
    "swipeHint": "برای عملیات بیشتر یادآور را بکشید",
    "noResults": "هیچ یادآوری با جستجوی شما مطابقت ندارد",
    "noResultsHint": "کلمه دیگری امتحان کنید یا جستجو را پاک کنید",
    "deleteAllFailed": "حذف همه یادآورها ناموفق بود"
  },
  "calendar": {
    "title": "تقویم",
    "today": "امروز",
    "tomorrow": "فردا",
    "completed": "انجام شده",
    "noEvents": "برنامه‌ای نیست",
    "noEventsSubtitle": "برای دیدن یادآورها و رویدادها تاریخ انتخاب کنید.",
    "googleEvent": "تقویم Google",
    "legendActive": "فعال",
    "legendRecurring": "تکراری",
    "legendDone": "انجام شده",
    "legendGoogle": "گوگل",
    "previousMonth": "ماه قبل",
    "nextMonth": "ماه بعد",
    "previousYear": "سال قبل",
    "nextYear": "سال بعد",
    "goToToday": "رفتن به امروز",
    "all": "همه",
    "active": "فعال",
    "done": "انجام شده",
    "paused": "متوقف"
  },
  "settings": {
    "title": "تنظیمات",
    "profile": "پروفایل",
    "name": "نام نمایشی",
    "enterName": "نام خود را وارد کنید",
    "language": "زبان",
    "uiLanguage": "زبان برنامه",
    "uiLanguageHelp": "فقط رابط کاربری، برچسب‌های تقویم و جهت‌بندی در این دستگاه تغییر می‌کند.",
    "serverLanguage": "زبان چت",
    "serverLanguageHelp": "زبان پاسخ‌های سرور و پیام‌های یادآوری برای حساب شما تغییر می‌کند.",
    "timezone": "منطقه زمانی",
    "currentTimezone": "منطقه زمانی فعلی",
    "timezoneHelp": "تمام زمان‌های یادآورها با این منطقه زمانی نمایش داده می‌شوند.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "ذخیره منطقه زمانی",
    "timezoneSaved": "منطقه زمانی به‌روزرسانی شد",
    "detect": "شناسایی",
    "detectFailed": "شناسایی منطقه زمانی ممکن نیست",
    "autoDetect": "شناسایی خودکار از GPS",
    "notifications": "اعلان‌ها",
    "notificationsHelp": "یادآوری‌های پیگیری هشدارهای تکراری پس از ارسال یادآوری را کنترل می‌کنند. مجوزهای اعلان دستگاه در تنظیمات گوشی مدیریت می‌شوند.",
    "pushEnabled": "اعلان‌های پوش",
    "autoDoneOnFire": "خودکار انجام شده هنگام فعال شدن",
    "autoDoneOnFireDesc": "اگر خاموش باشد، یادآورها فعال می‌مانند تا شما انجام شده علامت بزنید.",
    "googleCalendar": "تقویم Google",
    "google": "تقویم Google",
    "googleConnected": "متصل",
    "googleDisconnected": "متصل نیست",
    "googleConnectedHelp": "یادآورهای جدید می‌توانند به طور خودکار با تقویم شما همگام شوند.",
    "googleDisconnectedHelp": "برای هماهنگی یادآورها و رویدادها، تقویم Google را متصل کنید.",
    "googleConnectFailed": "اتصال به تقویم Google ناموفق بود",
    "connected": "متصل",
    "disconnected": "متصل نیست",
    "connect": "اتصال",
    "disconnect": "قطع اتصال",
    "autoSync": "همگام‌سازی خودکار یادآورهای جدید",
    "autosync": "همگام‌سازی خودکار یادآورهای جدید",
    "subscription": "اشتراک",
    "trialUsed": "آزمایشی: {{used}}/{{total}} استفاده شده",
    "trialStatus": "آزمایشی در دسترس",
    "activeStatus": "اشتراک فعال",
    "expiredStatus": "اشتراک منقضی شده",
    "unsubscribedStatus": "اشتراک ندارد",
    "about": "درباره",
    "version": "نسخه",
    "logout": "خروج",
    "logoutTitle": "خروج",
    "logoutConfirm": "آیا مطمئنید که می‌خواهید خارج شوید؟",
    "noName": "نام تنظیم نشده",
    "serverConnection": "اتصال سرور",
    "serverUrl": "آدرس سرور",
    "serverEdit": "ویرایش",
    "saveReconnect": "ذخیره و اتصال مجدد",
    "resetDefault": "بازنشانی به پیش‌فرض",
    "invalidServerUrlTitle": "آدرس سرور نامعتبر",
    "invalidServerUrlMessage": "آدرس سرور http یا https معتبر وارد کنید، مثلاً https://example.com",
    "uiLanguageChangeFailed": "تغییر زبان برنامه ناموفق بود. لطفاً دوباره تلاش کنید.",
    "serverLanguageChangeFailed": "تغییر زبان چت ناموفق بود. لطفاً دوباره تلاش کنید.",
    "timezoneChangeFailed": "تغییر منطقه زمانی ناموفق بود. لطفاً دوباره تلاش کنید.",
    "autoSyncChangeFailed": "به‌روزرسانی همگام‌سازی خودکار ناموفق بود. لطفاً دوباره تلاش کنید.",
    "nameChangeFailed": "به‌روزرسانی نام نمایشی ناموفق بود. لطفاً دوباره تلاش کنید.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "جزئیات یادآوری",
    "editTime": "ویرایش زمان",
    "rename": "تغییر نام",
    "snooze": "تعویق",
    "snooze15": "تعویق ۱۵ دقیقه",
    "pause": "توقف",
    "pauseReminder": "توقف یادآوری",
    "resume": "ادامه",
    "resumeReminder": "ادامه یادآوری",
    "skip": "رد کردن بعدی",
    "skipOccurrence": "رد این مورد",
    "syncGoogle": "همگام‌سازی با گوگل",
    "delete": "حذف",
    "deleteTitle": "حذف یادآوری",
    "deleteConfirm": "این یادآوری به طور دائمی حذف خواهد شد.",
    "deleteRecurringTitle": "حذف یادآوری تکراری",
    "deleteRecurringMessage": "می‌خواهید این مورد را رد کنید یا کل سری را حذف کنید؟",
    "deleteThisOccurrence": "رد این مورد",
    "deleteEntireSeries": "حذف کل سری",
    "done": "انجام شده",
    "markDone": "علامت‌گذاری به عنوان انجام شده",
    "undo": "بازگردانی",
    "undoPrompt": "نیاز به فعال شدن دوباره؟ همین حالا بازگردانید.",
    "recurring": "تکراری",
    "nextRun": "بار بعدی",
    "oneTime": "یک‌بار مصرف",
    "pending": "در انتظار",
    "sent": "ارسال شده",
    "paused": "متوقف",
    "active": "فعال",
    "snoozed": "تعویق شده",
    "localTime": "نمایش در زمان محلی شما",
    "recurrence": "تکرار",
    "created": "ایجاد شده",
    "tags": "برچسب‌ها",
    "fireCount": "تعداد فعال‌سازی",
    "actions": "عملیات",
    "none": "هیچ‌کدام",
    "snoozeFailed": "تعویق یادآوری ناموفق بود",
    "pauseFailed": "توقف یادآوری ناموفق بود",
    "resumeFailed": "ادامه یادآوری ناموفق بود",
    "skipFailed": "رد یادآوری ناموفق بود",
    "doneFailed": "علامت‌گذاری به عنوان انجام شده ناموفق بود",
    "undoFailed": "بازگردانی وضعیت یادآوری ناموفق بود",
    "deleteFailed": "حذف یادآوری ناموفق بود",
    "rescheduleTitle": "تعیین مجدد زمان؟",
    "rescheduleMsg": "این یادآوری سررسید گذشته است. می‌خواهید زمان آن را تغییر دهید؟",
    "reschedule15": "در ۱۵ دقیقه",
    "reschedule60": "در ۱ ساعت",
    "keepOverdue": "همان‌طور نگه دارید"
  },
  "onboarding": {
    "slide1Title": "به FishMemory خوش آمدید",
    "slide1Sub": "دستیار شخصی یادآوری شما — با قدرت WhatsApp و ساخته شده برای جیب شما.",
    "slide2Title": "فقط به صورت طبیعی چت کنید",
    "slide2Sub": "یادآورها را همانطور که فکر می‌کنید تایپ کنید: «یادآوری کن فردا ساعت ۳ با مامان تماس بگیرم» — بقیه را ما انجام می‌دهیم.",
    "slide3Title": "هیچ چیز را از دست ندهید",
    "slide3Sub": "اعلان‌های به موقع دریافت کنید، با برچسب‌ها سازماندهی کنید و روی همه چیز مهم کنترل داشته باشید.",
    "getStarted": "شروع کنید",
    "next": "بعدی",
    "firstReminderTitle": "اولین یادآوری خود را بسازید!",
    "firstReminderHint": "چیزی شبیه این را تایپ کنید:",
    "firstReminderExample": "یادآوری کن فردا ساعت ۹ صبح آب بنوشم",
    "gotIt": "فهمیدم!",
    "notifRationaleTitle": "به موقع بمانید",
    "notifRationaleBody": "FishMemory برای یادآوری به موقع به اعلان‌ها نیاز دارد. فقط برای یادآورهایی که می‌سازید هشدار دریافت می‌کنید.",
    "notifRationaleAllow": "فعال کردن اعلان‌ها",
    "notifRationaleLater": "شاید بعداً",
    "swipeHint": "برای عملیات سریع به راست بکشید →",
    "calendarDragHint": "کشیدن برای گسترش ↕"
  }
}
